<script>
export default {
  name: "ClearWnb",
  created() {
    localStorage.setItem("wnb-user", "false");
    this.$store.commit("WNB_USER", false);
  }
};
</script>

<style scoped></style>
